// @ts-nocheck
import { ReportTab, ReportTypeEnum } from 'sonata-static-storage/lib/schemas/report/reportTemplate.schema';

import { formatTimeFrame } from '@/helpers/reporting.helpers';

import type { DataByType, TabOptions } from '../types';

export const getInitialTabOptions = (
  userId: string,
  campaigns: string[],
  start: Date,
  end: Date,
  timezone: string,
  dataByType: DataByType,
  tabNumber: number,
  reportTab?: ReportTab
): TabOptions => ({
  campaigns: reportTab?.campaigns || campaigns,
  hasFootfallAttribution: dataByType.footfallAttribution.length > 0,
  hasViewability: dataByType.viewability.length > 0,
  includeFADwellTimeKpis: reportTab?.includeFADwellTimeKpis || false,
  options: {
    addressInfo: false,
    aggreggatedData: false,
    coordinatesInfo: false,
    decimalsType: 'comma',
    filters: [],
    footfallAttributionProviders: null,
    groups: ['day'],
    includeFADwellTimeKpis: false,
    includeUniques: false,
    sortBy: 'sdate',
    sortType: 'desc',
    viewabilityProviders: null,
    ...reportTab?.options
  },
  sheetName: reportTab?.sheetName || `Tab ${tabNumber}`,
  sheetType: (reportTab?.sheetType || ReportTypeEnum.stats) as keyof DataByType,
  timeFrame: reportTab?.timeFrame || 'fromStart',
  timezone: reportTab?.timezone || timezone,
  userIds: [userId],
  ...formatTimeFrame(
    {
      end: reportTab?.end || end,
      start: reportTab?.start || start
    },
    reportTab?.timezone || timezone
  ),
  columns: reportTab?.columns || dataByType.stats,
  fromTemplate: false,
  includeCustomKpis: reportTab?.includeCustomKpis || false,
  isCustomSelectedCampaings:
    Boolean(reportTab?.campaigns) && (reportTab?.campaigns?.length ?? campaigns.length) < campaigns.length
});
